<template>
  <div>
    <v-container>
        <v-row
        class="d-flex justify-center mt-16 bg_mode pa-3"
        style="border-left: 2px solid #01994C; border-right: 2px solid #01994C"
      >
        <h1 class="color-main">{{ langkeyword("ABOUT_US") }}</h1>
      </v-row>

          <v-card class="p-2  text-center d-flex justify-center mt-16">
      <p class="text-center col-11">
        <span v-if="lang() === 'ku'">{{
          this.$store.state.setting.ku_about
        }}</span>
        <span v-if="lang() === 'ar'">{{
          this.$store.state.setting.ar_about
        }}</span>
        <span v-if="lang() === 'en'">{{
          this.$store.state.setting.en_about
        }}</span>
      </p>
    </v-card>

      </v-container>

    <!-- Co-Founder Section -->
        <h1 class="color-main text-center mt-3 mb-0">{{ langkeyword("CO_FOUNDER") }}</h1>
    <v-row class="d-flex justify-center align-start mt-3 mb-12">
      <v-col cols="12" md="10" lg="8" class="d-flex justify-center">
        <v-card class="cofounder-sidecard elevation-10" max-width="1000px" width="100%" style="border:#01994C 2px solid">
          <div class="cofounder-flex-wrapper">
            <div class="cofounder-sidecard-img">
              <v-img
                :src="coFounderImageSrc"
                alt="Co-Founder Photo"
                :class="'cofounder-img-flat ' + lang()"
                height="100%"
                width="100%"
                style="width:100% !important;height:100% !important;object-fit:cover !important;object-position:center top !important;display:block !important;background-position:center top !important;"
              />
            </div>
            <div class="cofounder-sidecard-desc pa-4" style="flex: 1 1 0%; height: 100%;">
              <div class="w-100">
                <h3 class="font-weight-bold color-main mb-2 cofounder-title">{{ langkeyword('FOUNDER') }}</h3>
                <p v-if="lang() === 'ku'" class="cofounder-sidecard-text ku" v-html="$store.state.setting.ku_cofounder"></p>
                <p v-if="lang() === 'ar'" class="cofounder-sidecard-text ar" v-html="$store.state.setting.ar_cofounder"></p>
                <p v-if="lang() === 'en'" class="cofounder-sidecard-text en" v-html="$store.state.setting.en_cofounder"></p>
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <!-- End Co-Founder Section -->

    <appFooter />
  </div>
</template>

<script>
import appFooter from "../../layouts/client/footer.vue";
export default {
  components: { appFooter },
  computed: {
    coFounderImageSrc() {
      const img = this.$store.state.setting.cofounder_img;
      if (img) {
        if (img.startsWith('http')) return img;
        return this.$store.state.serverurl + '/api/server/uploads/setting/' + img;
      }
      // fallback image (use relative path for webpack compatibility)
      return require('@/assets/img/footer-logo.png');
    }
  }
};
</script>

<style lang="scss" scoped>


.cofounder-sidecard {
  background: var(--client-bg, #fff);
  border-radius: 24px;
  box-shadow: 0 8px 32px rgba(1, 153, 76, 0.10);
  overflow: hidden;
  border: 1.5px solid #e0e0e0;
  transition: box-shadow 0.3s;
  display: flex;
  flex-direction: column;
}
.theme--dark .cofounder-sidecard {
  background: var(--client-bg-dark, #23272f);
  border: 1.5px solid #333;
  box-shadow: 0 8px 32px rgba(67, 233, 123, 0.10);
}
// Responsive flex wrapper for cofounder card
.cofounder-flex-wrapper {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  min-height: 320px;
  height: auto;
}
  .cofounder-sidecard-img {
    flex: 0 0 320px;
    min-width: 220px;
    max-width: 400px;
    height: 100%;
    padding: 0 !important;
    display: flex;
    align-items: stretch;
    justify-content: stretch;
    margin: 0;
    overflow: hidden;
  }
  .cofounder-img-flat {
    object-fit: cover !important;
    width: 100% !important;
    height: 100% !important;
    min-height: 220px;
    max-height: 100%;
    display: block;
    object-position: center top !important;
    background-position: center top !important;
  }
  
  // Force override Vuetify's background-position
  .cofounder-img-flat ::v-deep .v-image__image {
    background-position: center top !important;
  }
// Desktop/tablet: border left for ku/ar, right for en
.cofounder-img-flat.ku {
  border-radius: 30px 0 0 30px;
  border-left: #01994C 5px solid;
  border-right: none;
  border-bottom: none;
}
.cofounder-img-flat.ar {
  border-radius: 30px 0 0 30px;
  border-left: #01994C 5px solid;
  border-right: none;
  border-bottom: none;
}
.cofounder-img-flat.en {
  border-radius: 0 30px 30px 0;
  border-right: #01994C 5px solid;
  border-left: none;
  border-bottom: none;
}

@media (max-width: 900px) {
  // On mobile, always border-bottom, no left/right borders
  .cofounder-img-flat.ku,
  .cofounder-img-flat.ar,
  .cofounder-img-flat.en {
    border-radius: 0 0 30px 30px !important;
    border-left: none !important;
    border-right: none !important;
    border-bottom: #01994C 5px solid !important;
  }
}
.cofounder-sidecard-desc {
  background: transparent;
  padding-top: 12px;
  padding-bottom: 12px;
  flex: 1 1 auto;
  min-width: 0;
  height: auto;
  overflow: visible;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.cofounder-title {
  font-size: 1.3rem;
  line-height: 1.2;
}
.cofounder-sidecard-text {
  font-size: 1.05rem;
  color: var(--client-text, #333);
  line-height: 1.7;
  font-weight: 400;
  letter-spacing: 0.01em;
  word-break: break-word;
  margin-bottom: 0;
}
.theme--dark .cofounder-sidecard-text {
  color: var(--client-text-dark, #eee);
}
.cofounder-sidecard-text.ku { font-family: 'rabar', sans-serif; }
.cofounder-sidecard-text.ar { font-family: 'rudaw', sans-serif; }
.cofounder-sidecard-text.en { font-family: 'Roboto', sans-serif; }

@media (max-width: 900px) {
  .cofounder-flex-wrapper {
    flex-direction: column;
    align-items: stretch;
    height: auto;
  }
  .cofounder-sidecard-img {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    aspect-ratio: 1.2/1;
    height: auto;
    margin-bottom: 12px;
    justify-content: stretch;
    position: relative;
    min-height: 180px;
    overflow: hidden;
  }
  .cofounder-img-flat {
    width: 100% !important;
    height: 100% !important;
    min-height: 180px;
    min-width: 100px;
    max-height: none;
    max-width: 100%;
    object-fit: cover !important;
    object-position: center top !important;
    background-position: center top !important;
    position: absolute !important;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    display: block;
  }
  
  // Force override Vuetify's background-position on mobile
  .cofounder-img-flat ::v-deep .v-image__image {
    background-position: center top !important;
  }
  .cofounder-sidecard-desc {
    padding: 8px 10px 0 10px;
    height: auto;
    overflow: visible;
  }
  .cofounder-title {
    font-size: 1.1rem;
  }
  .cofounder-sidecard-text {
    font-size: 0.98rem;
    line-height: 1.5;
  }
}
</style>
